import { useState } from 'react';

import type { ClientId } from '@nesso/ledger-contracts/ids';
import { Sheet, SheetContent } from '@nesso/ui/primitives/sheet';

import type { Payment } from '@/entities/payment';

import { RefundPaymentSheetContent } from './refund-payment-sheet/refund-payment-sheet-content';

type Props = {
    clientId: ClientId;
    clientName: string;
    payment: Payment | null;
    open: boolean;
    onOpenChange: (open: boolean) => void;
};

export function RefundPaymentSheet({ clientId, clientName, payment, open, onOpenChange }: Props) {
    const [pending, setPending] = useState(false);

    function handleOpenChange(next: boolean) {
        if (pending) return;
        onOpenChange(next);
    }

    if (!payment) return null;

    return (
        <Sheet open={open} onOpenChange={handleOpenChange}>
            <SheetContent side="right" size="medium" variant="chart" showCloseButton={false}>
                <RefundPaymentSheetContent
                    clientId={clientId}
                    clientName={clientName}
                    payment={payment}
                    onClose={() => onOpenChange(false)}
                    onBreadcrumbNavigate={(navigate) => {
                        if (pending) return;
                        navigate();
                        onOpenChange(false);
                    }}
                    onPendingChange={setPending}
                />
            </SheetContent>
        </Sheet>
    );
}
